function useScroll() {
  const scrollToTop = (to = 0) => {
    window.scrollTo({
      top: to,
      behavior: 'smooth',
    });
  };

  return { scrollToTop };
}

export default useScroll;
